import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import { OverlayEventDetail } from '@ionic/core';
import { AlertController, ModalController } from '@ionic/angular';

import { AjaxService } from '../ajax.service';
import { ScanCameraPage } from '../scan-camera/scan-camera.page';

interface ApiResponse {
  login: boolean;
  txt: any;
  des?: string;
  eenh?: string;
  loc?: string;
  vrd?: number;
  vvrd?: number;
  mvrd?: number;
  verbruik?: number;
  foto?: boolean;
}

@Component({
    selector: 'app-overboeking',
    templateUrl: './overboeking.page.html',
    styleUrls: ['./overboeking.page.scss'],
    standalone: false
})
export class OverboekingPage implements OnInit {
  inpProjVan = '';
  projlistVan: any[] = [];
  projShowVan: any = {
    nr: '',
    descr: ''
  };

  inpProjNr = '';
  projlistNr: any[] = [];
  projShowNr: any = {
    nr: '',
    descr: ''
  };

  artlist: any[] = [];
  inpArtnr = '';
  artShow: any = {
    nr: '',
    descr: '',
    voorraad: 0,
    voorraadTxt: '',
    vrijevoorraad: 0,
    verbruik: 0,
    locatie: '',
    minvr: 0
  };
  validArt = false;

  inpQty: number = null;
  imgs = [];
  viewerOpen = false;
  scanCamera = false;

  @ViewChild('inputArtnr', {static: true}) inputArt: ElementRef; // for set focus

  constructor(
    private router: Router,
    public global: GlobalService,
    public alertController: AlertController,
    public http: HttpClient,
    public modalController: ModalController,
    private ajax: AjaxService,
  ) { }

  ngOnInit() {
    if (!this.global.isLoggedIn) {
      this.router.navigateByUrl('login');
    }
  }

  ionViewWillEnter() {
    this.inputArt.nativeElement.focus();

    const  projnr: string = localStorage.getItem('lastProjNr');
    if (projnr) {
      this.inpProjVan = projnr;
      this.showProjKaart('VAN', projnr);
    }

  }

    async doScanProj(target) {
        if (!await this.global.startCamera()) {
            return;
        }
        this.scanCamera = true;
        const myDlg = await this.modalController.create({
            component: ScanCameraPage,
        });
        myDlg.onDidDismiss()
        .then((dataPar: OverlayEventDetail) => {
            this.scanCamera = false;
            if (dataPar.data.code) {
                if (target === 'VAN') {
                    this.inpProjVan = dataPar.data.code;
                } else {
                    this.inpProjNr = dataPar.data.code;
                }
                this.showProjKaart(target, dataPar.data.code);
            }
        });
        return await myDlg.present();
    }

  click_proj(target, nwProjNr) {
    if (target === 'VAN') {
      this.inpProjVan = nwProjNr;
      this.projlistVan = [];
    } else {
      this.inpProjNr = nwProjNr;
      this.projlistNr = [];
    }
    this.showProjKaart(target, nwProjNr);
  }

  // Called during typing of projectnr
  onChangeProj(target, nwProjNr) {
    console.log('onChangeProj: ' + nwProjNr);
    this.ajax.get('projList', {req: nwProjNr})
    .then((data: any) => {
        console.log('ProjList = ', data);
        if (target === 'VAN') {
          this.projlistVan = data.txt;
        } else {
          this.projlistNr = data.txt;
        }
        if (data.txt.length === 1
          && data.txt[0].nr.toLowerCase() === nwProjNr.toLowerCase()) {
            this.click_proj(target, data.txt[0].nr);
        } else {
          data.txt.forEach(element => {
            if (element.nr.toLowerCase() === nwProjNr.toLowerCase()) {
              this.showProjKaart(target, nwProjNr);
            }
          });
        }
      }
    );
  }

  showProjKaart(target, projnr) {
    console.log('showProjKaart: ' + projnr);
    this.ajax.get('projData', {req: projnr})
    .then((data: any) => {
        if (target === 'VAN') {
          this.projShowVan.descr = data.des;
          this.global.currProjNr = projnr;
          localStorage.setItem('lastProjNr', projnr);
        } else {
          this.projShowNr.descr = data.des;
        }
      }
    );
  }


  /*---------------------
  * ARTIKEL INVOER
  ----------------------- */

    async doScanArt() {
        if (!await this.global.startCamera()) {
            return;
        }
        this.scanCamera = true;
        const myDlg = await this.modalController.create({
            component: ScanCameraPage,
        });
        myDlg.onDidDismiss()
        .then((dataPar: OverlayEventDetail) => {
            this.scanCamera = false;
            if (dataPar.data.code) {
                this.inpArtnr = dataPar.data.code;
                this.showArtKaart(this.inpArtnr);
            }
        });
        return await myDlg.present();
    }

  // called during typing of partnr
  onChangeArt(nwArtNr) {
    console.log('onChangeArt: ' + nwArtNr);
    this.ajax.get('artList', {req: nwArtNr})
    .then((data: any) => {
        console.log('artList = ', data);
        this.artlist = data.txt;
        if ((this.artlist.length === 1 && this.artlist[0].nr.toLowerCase === nwArtNr.toLowerCase())
            || data.msg === 'FOUND 1'
        ) {
            this.click_art(this.artlist[0].nr);
        } else {
          data.txt.forEach(element => {
            if ( element.nr.toLowerCase() === nwArtNr.toLowerCase() ) {
              this.showArtKaart(nwArtNr);
            }
          });
        }
      }
    );
  }

  click_art(nwArtNr) {
    this.inpArtnr = nwArtNr;
    this.artlist = [];
    this.showArtKaart(nwArtNr);
  }

  // when partnr fulfilled, show details
  showArtKaart(artnr) {
    console.log('showArtKaart: ' + artnr);
    this.ajax.get('artData', {req: artnr})
    .then((data: any) => {
        console.log('got5 = ', data);
        this.artShow.nr = data.artnr;
        this.inpArtnr = data.artnr;
        this.validArt = true;
        this.artShow.descr = data.des;
        this.artShow.eenh = data.eenh;
        this.artShow.voorraad = data.vrd;
        this.artShow.voorraadTxt = 'Voorraad: ' + this.artShow.voorraad;
        this.artShow.metFoto = data.foto;

        this.artShow.imgUrl = this.global.baseurl
          + 'api/img.php?t=artikelen&f=Foto&i=ArtNr&v=' + artnr
          + '&compname=' + this.global.compname
          + '&username=' + this.global.username
          + '&password=' + this.global.password
          + '&session=' + this.global.session
          + '&app=BAR3'
          + '&pcnr=' + this.global.uuid;
        this.imgs[0] = {
            filename: data.artnr,
            path: '',
            txt: data.artnr,
            url: this.artShow.imgUrl
        };

        this.global.currArtNr = data.artnr;
        localStorage.setItem('lastArtNr', data.artnr);
      }
    );
  }

  doOverboek() {
    this.ajax.get('artVerplaats', {
        req: this.global.currArtNr,
        par2: this.inpProjVan,
        proj: this.inpProjNr,
        qty: this.inpQty
    })
    .then((data: any) => {
        console.log('got7 = ', data);
        this.inpArtnr = '';
        this.validArt = false;
        this.artShow.nr = '';
        this.artShow.descr = '';
        this.artShow.eenh = '';
        this.artShow.voorraad = null;
        this.artShow.voorraadTxt = '';
        this.inpQty = null;

        this.inputArt.nativeElement.focus();
      }
    );

  }

}
